import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (!this.authService.isAuthenticated()) {
      void this.router.navigate(['/auth'], {
        queryParams: { returnUrl: state.url },
      });
      return false;
    }

    if (this.authService.userRole() === 'ADMIN') {
      return true;
    }

    const requiredRoles = route.data['roles'] as Array<'ADMIN' | 'STUDENT'> | undefined;
    if (!requiredRoles?.length) {
      return true;
    }

    if (this.authService.hasAnyRole(requiredRoles)) {
      return true;
    }

    void this.router.navigate([this.authService.defaultRoute()]);
    return false;
  }
}
